import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollWindowToTop } from '../utils/scrollPosition';

/**
 * ScrollToTop Component
 * 
 * Diese Komponente scrollt die Seite automatisch nach oben,
 * wenn sich die Route ändert (Navigation zu einer neuen Seite).
 * 
 * Das löst das Problem, dass bei mobilen Geräten Seiten oft
 * "mittig" geladen werden, weil React Router die Scroll-Position beibehält.
 * 
 * Verwendung: Einfach innerhalb des <Router> in App.js einbinden.
 * 
 * Created: Feb 2026 (UX Fix für Mobile Scroll Issues)
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll zum Anfang der Seite bei jeder Navigation.
    //
    // WICHTIG: In der App-Ansicht ist NICHT das window der Scroll-Container.
    // index.css setzt fuer Native/WKWebView html UND body auf
    // height:100% + overflow-y:auto -> der body (bzw. html) scrollt, nicht
    // das window. Dann bewegt window.scrollTo() auf iOS gar nichts.
    // Deshalb setzen wir alle moeglichen Scroll-Quellen zurueck
    // (analog zu getDocumentScrollTop() in utils/scrollPosition.js).
    const scrollAllToTop = () => {
      // window + body/html/scrollingElement zuruecksetzen (iOS WKWebView)
      scrollWindowToTop('instant');

      // Zusätzlich: scrollbare Container mit explizitem Marker zurücksetzen
      // (Seiten mit eigenem overflow-Container koennen data-scroll-container setzen)
      const scrollableContainers = document.querySelectorAll('[data-scroll-container]');
      scrollableContainers.forEach(container => {
        container.scrollTop = 0;
      });
    };

    // Sofort scrollen ...
    scrollAllToTop();
    // ... und erneut im naechsten Frame: Lazy/Suspense-Routen rendern zuerst
    // ein Skeleton und legen das finale Layout erst danach fest.
    const raf = requestAnimationFrame(scrollAllToTop);

    return () => cancelAnimationFrame(raf);
  }, [pathname]); // Trigger bei jeder Pfad-Änderung

  return null; // Rendert nichts sichtbares
};

export default ScrollToTop;




